/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_USERS, GET_USERS } from 'src/actions/userActions';

const initialState = {
  items: [],
  total: 0,
  isFetching: false,
  message: ''
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_USERS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_USERS: {
      const { users, total, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = users;
        draft.total = total;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default userReducer;
